/**
 * Copyright IBM Corp. 2022, 2026
 */

import { vercelSplit } from '@web/cms'
import s from './style.module.css'

const Anchor = ({ anchorId }: { anchorId: string }) => {
	return <div id={vercelSplit(anchorId)} className={s.root} />
}

export default Anchor
